/**
 * Shared Stripe Payment Element appearance configuration.
 */
export const buildStripeAppearance = () => {
    return {
        theme: 'stripe',
        inputs: 'spaced',
        labels: 'above',
        variables: {
            colorPrimary: '#006ceb',
            colorText: '#000000CC',
            colorDanger: '#e02500',
            colorSuccess: '#2b852a',
            colorWarning: '#8f7004',
            fontFamily: 'sans-serif',
            iconCardCvcColor: 'black',
            spacingUnit: '4px',
            borderRadius: '12px',
        },
        rules: {
            '.Input': {
                borderColor: '#757575',
            },
            '.Input:focus': {
                borderColor: '#266EF1',
            },
        },
    }
}
